import React from 'react';
import CaseList from '../components/CaseList';

const SalesCases: React.FC = () => {
  return <CaseList caseType="sales" title="Sales Cases" icon="💼" color="blue" />;
};

export default SalesCases;
